import React from 'react';
// styles
import { RelatedLinksStyled } from './styles';

export default () => {
  const linkItems = [
    {
      linkUrl: '/fixed-annuity-vs-variable-annuity/prospectus-and-reports/',
      linkId: 'related-links-prospectus-and-reports',
      linkText: 'Prospectus and Reports',
      ariaLabel: '',
      isOutgoingLink: false,
      children: '',
    },
    {
      linkUrl: '/fixed-annuity-vs-variable-annuity/underlying-fund-information/',
      linkId: 'related-links-underlying-fund-information',
      linkText: 'Fund Information',
      ariaLabel: '',
      isOutgoingLink: false,
      children: '',
    },
    {
      linkUrl: '/fixed-annuity-vs-variable-annuity/performance-history/',
      linkId: 'related-links-performance-history',
      linkText: 'Performance History',
      ariaLabel: '',
      isOutgoingLink: false,
      children: '',
    },
    {
      linkUrl: '/annuities/general-investment-risk-disclosures/',
      linkId: 'related-links-general-investment-risk-disclosures',
      linkText: 'General Investment Risk Disclosures',
      ariaLabel: '',
      isOutgoingLink: false,
      children: '',
    },
    {
      linkUrl: '/annuities/daily-unit-values/',
      linkId: 'related-links-daily-unit-values',
      linkText: 'Daily Unit Values',
      ariaLabel: '',
      isOutgoingLink: false,
      children: '',
    },
  ];

  return (
    <RelatedLinksStyled
      sectionId='related-links-fixed-variable-annuities-page'
      linkItems={linkItems}
      moduleName='related-links'
      moduleVariation='A'
      backgroundVariant='lightA'
      themeType='lightTheme'
      disableBottomPadding />
  );
};
